import { render, staticRenderFns } from "./ListarDiarioCAeeTurmaPage.vue?vue&type=template&id=4b6c47dd&scoped=true"
import script from "./ListarDiarioCAeeTurmaPage.vue?vue&type=script&lang=js"
export * from "./ListarDiarioCAeeTurmaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c47dd",
  null
  
)

export default component.exports